import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

// Components
import Grid from '../../../components/grid';
import GridItem from '../../../components/grid/gridItem';
import ListLink from './listLink';

function NewsList({ filteredNews, activeChips }) {
    const [itemsToShow, setItemsToShow] = useState(9);
    const [isExpanded, setIsExpanded] = useState(false);

    const showMore = (count) => {
        if (itemsToShow === count) {
            setItemsToShow(filteredNews.length);
            setIsExpanded(true);
        } else {
            setItemsToShow(count);
            setIsExpanded(false);
        }
    };

    useEffect(() => {
        if (activeChips.length && filteredNews.length >= 6) {
            setItemsToShow(6);
        } else {
            setItemsToShow(9);
            setIsExpanded(false);
        }
    }, [activeChips]);

    useEffect(() => {
        if (activeChips.length && itemsToShow >= 9) {
            setItemsToShow(filteredNews.length);
            setIsExpanded(true);
        }
    }, [itemsToShow]);

    return (
        <div className={'new-news_grid flex'}>
            <Grid>
                {filteredNews.slice(0, itemsToShow).map((item, idx) => {
                    const { newsDetailItems, slug, url, image, title, description } = item.fields;
                    return (
                        <AnimatePresence key={idx}>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}>
                                <GridItem>
                                    <ListLink
                                        slug={slug}
                                        url={url}
                                        image={image}
                                        title={title}
                                        description={description}
                                        newsDetailItems={newsDetailItems}
                                    />
                                </GridItem>
                            </motion.div>
                        </AnimatePresence>
                    );
                })}
            </Grid>

            {filteredNews.length <= 6 ? (
                ''
            ) : activeChips.length && itemsToShow >= 9 ? (
                <button onClick={() => showMore(6)} className={'btn-route'}>
                    {isExpanded ? 'Show Less' : 'Show More'}
                </button>
            ) : (
                <button
                    onClick={() => showMore(filteredNews.length >= 9 ? 9 : 6)}
                    className={'btn-route'}>
                    {isExpanded ? 'Show Less' : 'Show More'}
                </button>
            )}
        </div>
    );
}

export default NewsList;
